import React from "react";

export const services = [
    {
        id: "sitevitrine",
        title: "Site Vitrine",
        shortTitle: "Site Vitrine",
        slug: "site-vitrine",
        icon: (
            <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
                />
            </svg>
        ),
        iconBg: (
            <svg
                className="w-full h-full"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
                />
            </svg>
        ),
        iconBgClass: "bg-blue-50 text-blue-600",
        shortDescription: "Présentez votre entreprise sur internet",
        description:
            "Nous créons des sites vitrines élégants et efficaces qui présentent parfaitement votre activité, vos services et vos valeurs aux visiteurs.",
        gradientColors: "from-blue-500 to-indigo-600",
        benefits: [
            "Design moderne et personnalisé",
            "Optimisé pour les moteurs de recherche",
            "Adapté à tous les appareils (responsive)",
            "Facile à mettre à jour",
        ],
        features: [
            {
                name: "Visibilité",
                value: "+80%",
                description: "Amélioration moyenne de la présence en ligne",
            },
            {
                name: "Contacts",
                value: "+65%",
                description: "Augmentation des demandes de contact",
            },
            {
                name: "Image",
                value: "+75%",
                description: "Amélioration de l'image professionnelle",
            },
        ],
        deliveryTime: "3-6 semaines",
        deliverables: "Site web, hébergement, formation, manuel d'utilisation",
    },
    {
        id: "ecommerce",
        title: "Boutique en Ligne",
        shortTitle: "E-commerce",
        slug: "boutique-en-ligne",
        icon: (
            <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                />
            </svg>
        ),
        iconBg: (
            <svg
                className="w-full h-full"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                />
            </svg>
        ),
        iconBgClass: "bg-green-50 text-green-600",
        shortDescription: "Vendez vos produits en ligne facilement",
        description:
            "Nous développons des boutiques en ligne attractives et faciles à utiliser qui vous permettent de vendre vos produits ou services 24h/24.",
        gradientColors: "from-green-500 to-emerald-500",
        benefits: [
            "Paiements sécurisés et multiples moyens de paiement",
            "Gestion simple des produits et des stocks",
            "Expérience d'achat optimisée pour augmenter les ventes",
            "Intégration avec vos outils de gestion existants",
        ],
        features: [
            {
                name: "Ventes",
                value: "+120%",
                description: "Augmentation moyenne du chiffre d'affaires",
            },
            {
                name: "Conversion",
                value: "+45%",
                description:
                    "Amélioration du taux de conversion visiteur/acheteur",
            },
            {
                name: "Abandon",
                value: "-30%",
                description: "Réduction du taux d'abandon de panier",
            },
        ],
        deliveryTime: "6-12 semaines",
        deliverables:
            "Boutique en ligne complète, formation, assistance au démarrage",
    },
    {
        id: "webdesign",
        title: "Design Web",
        shortTitle: "Webdesign",
        slug: "webdesign",
        icon: (
            <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
                />
            </svg>
        ),
        iconBg: (
            <svg
                className="w-full h-full"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
                />
            </svg>
        ),
        iconBgClass: "bg-pink-50 text-pink-600",
        shortDescription: "Un design qui vous démarque",
        description:
            "Nous créons des designs web uniques et attrayants qui captent l'attention de vos visiteurs et reflètent l'identité de votre entreprise.",
        gradientColors: "from-pink-500 to-rose-500",
        benefits: [
            "Design sur mesure adapté à votre image",
            "Interface intuitive et agréable à utiliser",
            "Identité visuelle cohérente",
            "Expérience utilisateur optimisée",
        ],
        features: [
            {
                name: "Engagement",
                value: "+70%",
                description: "Augmentation du temps passé sur le site",
            },
            {
                name: "Mémorisation",
                value: "+85%",
                description: "Amélioration du souvenir de votre marque",
            },
            {
                name: "Satisfaction",
                value: "95%",
                description: "Taux de satisfaction des utilisateurs",
            },
        ],
        deliveryTime: "2-4 semaines",
        deliverables:
            "Maquettes, design responsive, assets graphiques, guide de style",
    },
    {
        id: "mobile",
        title: "Application Mobile",
        shortTitle: "App Mobile",
        slug: "application-mobile",
        icon: (
            <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
                />
            </svg>
        ),
        iconBg: (
            <svg
                className="w-full h-full"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
                />
            </svg>
        ),
        iconBgClass: "bg-yellow-50 text-yellow-600",
        shortDescription: "Votre entreprise dans la poche de vos clients",
        description:
            "Nous développons des applications mobiles performantes et intuitives pour iOS et Android qui permettent à vos clients d'accéder à vos services partout.",
        gradientColors: "from-yellow-500 to-amber-500",
        benefits: [
            "Interface utilisateur intuitive et moderne",
            "Fonctionnalités sur mesure selon vos besoins",
            "Compatibilité iOS et Android",
            "Synchronisation avec votre site web",
        ],
        features: [
            {
                name: "Fidélisation",
                value: "+85%",
                description: "Amélioration du taux de fidélisation client",
            },
            {
                name: "Engagement",
                value: "+120%",
                description: "Augmentation de l'engagement utilisateur",
            },
            {
                name: "Visibilité",
                value: "24/7",
                description:
                    "Présence permanente sur les appareils des clients",
            },
        ],
        deliveryTime: "8-16 semaines",
        deliverables:
            "Application iOS et Android, publication sur les stores, support technique",
    },
    {
        id: "redesign",
        title: "Refonte de Site",
        shortTitle: "Refonte",
        slug: "refonte-site",
        icon: (
            <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                />
            </svg>
        ),
        iconBg: (
            <svg
                className="w-full h-full"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                />
            </svg>
        ),
        iconBgClass: "bg-purple-50 text-purple-600",
        shortDescription: "Modernisez votre présence en ligne",
        description:
            "Nous transformons votre site web existant en une plateforme moderne, performante et adaptée aux standards actuels du web.",
        gradientColors: "from-purple-500 to-indigo-500",
        benefits: [
            "Design actualisé et contemporain",
            "Amélioration des performances techniques",
            "Optimisation pour les moteurs de recherche",
            "Adaptation à tous les appareils mobiles",
        ],
        features: [
            {
                name: "Performance",
                value: "+150%",
                description: "Amélioration moyenne de la vitesse de chargement",
            },
            {
                name: "Trafic",
                value: "+95%",
                description: "Augmentation du nombre de visiteurs",
            },
            {
                name: "Interaction",
                value: "+120%",
                description: "Amélioration du taux d'engagement",
            },
        ],
        deliveryTime: "4-8 semaines",
        deliverables:
            "Audit du site existant, nouveau site, migration des données",
    },
    {
        id: "seo",
        title: "Référencement SEO",
        shortTitle: "SEO",
        slug: "referencement-seo",
        icon: (
            <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M7 11l5-5m0 0l5 5m-5-5v12"
                />
            </svg>
        ),
        iconBg: (
            <svg
                className="w-full h-full"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M7 11l5-5m0 0l5 5m-5-5v12"
                />
            </svg>
        ),
        iconBgClass: "bg-teal-50 text-teal-600",
        shortDescription: "Augmentez votre visibilité sur Google",
        description:
            "Nous optimisons votre site pour les moteurs de recherche afin d'attirer plus de visiteurs qualifiés et d'améliorer votre positionnement sur Google.",
        gradientColors: "from-teal-500 to-cyan-500",
        benefits: [
            "Audit SEO complet de votre site",
            "Optimisation du contenu et des mots-clés",
            "Amélioration de la structure technique",
            "Stratégie de création de liens",
        ],
        features: [
            {
                name: "Trafic",
                value: "+120%",
                description: "Augmentation moyenne du trafic organique",
            },
            {
                name: "Classement",
                value: "Top 10",
                description: "Positionnement pour vos mots-clés cibles",
            },
            {
                name: "Conversion",
                value: "+45%",
                description: "Amélioration du taux de conversion des visiteurs",
            },
        ],
        deliveryTime: "3-5 mois",
        deliverables:
            "Audit initial, rapport mensuel, optimisations on-page, stratégie de contenu",
    },
];
